import React from 'react';
import kalpanax1 from '../assets/image/kalpanax1.svg';
import kalpanax2 from '../assets/image/kalpanax2.svg';
import kalpanax3 from '../assets/image/kalpanax3.svg';

const SkinPhotoGuidelinesModal = ({ isOpen, onClose, onContinue }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-[#FAE5C7] rounded-lg max-w-md w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="p-6 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-center text-black">
            Panduan Pengambilan Foto Kulit<br />
            untuk Pengecekan
          </h2>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          {/* Section 1: Clarity and Focus */}
          <div className="space-y-3">
            <h3 className="font-normal text-black">
              1. Foto Harus Jelas dan Tidak Boleh Blur
            </h3>
            <div className="flex space-x-3">
              <img src={kalpanax1} alt="Foto Jelas" className="w-full h-28 object-contain rounded-lg" />
            </div>
          </div>

          {/* Section 2: Distance */}
          <div className="space-y-3">
            <h3 className="font-normal text-black">
              2. Jarak Pengambilan Foto berjakal +/- 25 cm agar system dapat mendeteksi Objek yang akan di analisa, jarak foto dengan objek tidak boleh terlalu jauh
            </h3>
            <div className="flex space-x-3">
              <img src={kalpanax2} alt="Foto Jelas" className="w-full h-28 object-contain rounded-lg" />
            </div>
          </div>

          {/* Section 3: Cropping */}
          <div className="space-y-3">
            <h3 className="font-normal text-black">
              3. Gunakan Fitur Crop pada system untuk menyesuaikan gambar agar tidak ada objek lain selain objek yang akan dianalisa system.
            </h3>
            <div className="flex space-x-3">
              <img src={kalpanax3} alt="Foto Jelas" className="w-full h-28 object-contain rounded-lg" />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-center p-6 border-t border-gray-200">
          <button
            onClick={onContinue}
            className="w-64 bg-red text-white font-bold py-3 px-4 rounded-lg hover:bg-red-700 transition-colors"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default SkinPhotoGuidelinesModal; 